/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function setNaviBarRightItem(options, context) {
    var _a;
    var api = 'dd.biz.navigation.setRight';
    var formatInput = function (input) { return ({
        show: true,
        control: true,
        text: input.title,
        onSuccess: function (e) {
            var onClick = (input === null || input === void 0 ? void 0 : input.onClick) || function () { };
            onClick(e);
        },
    }); };
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput });
}

export { setNaviBarRightItem as default };
